/**
 * 临时记录数据类型
 */
export enum TempRecordType {
  TOKEN_CYCLE = 'token_cycle', // token周期内生效，登录/退出时清除
  DAILY_RESET = 'daily_reset', // 每日重置，当日生效
  GLOBAL_ONCE = 'global_once', // 全局一次性开关
}

/**
 * 临时记录项接口
 */
export interface TempRecordItem {
  value: any;
  type: TempRecordType;
  timestamp: number;
  expireDate?: string; // 对于DAILY_RESET类型，记录过期日期
}

/**
 * 临时记录状态接口
 */
export interface TempRecordState {
  records: Record<string, Record<string, TempRecordItem>>; // 第一层key为用户ID，第二层key为记录键名
}

/**
 * 常用的记录键名常量
 */
export const TEMP_RECORD_KEYS = {
  /** 顶部栏关闭状态 */
  TOPBAR_CLOSED: 'topbar_closed',
  /** 高清模式弹窗展示状态 */
  HD_MODE_MODAL_SHOWN: 'hd_mode_modal_shown',
  /** SVIP 并发限制弹窗当日已展示（每日重置） */
  SVIP_CONCURRENT_LIMIT_MODAL_SHOWN: 'svip_concurrent_limit_modal_shown',
  /** 模型详情页（sectionDetail）对比模式偏好 */
  MODEL_DETAIL_COMPARE_VIEW_MODE: 'model_detail_compare_view_mode',
  /** 模型详情弹窗（ModelDetailsModal）对比模式偏好 */
  MODEL_MODAL_COMPARE_VIEW_MODE: 'model_modal_compare_view_mode',
} as const;